export const legacyApiBasePath = process.env.REACT_APP_DPLOY_LEGACY_API || "";
export const apiBasePath = process.env.REACT_APP_DPLOY_API || "";
